import { atom } from "recoil";

export const settingsAtom = atom({
  key: "setttingsAtom",
  default: null,
  // default: settingsJSON,
});
export const mapSettingsAtom = atom({
  key: "mapSettingsAtom",
  default: false,
});

export const underMaintenanceAtom = atom({
  key: "underMaintenanceAtom",
  default: false,
});

export const noRideIdAtom = atom({
  key: "noRideIdAtom",
  default: null,
});

export const callSettingsAtom = atom({
  key: "callSettingsAtom",
  default: null,
});


